// TODO: MAX CLASS!!
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { confirmDialog } from 'primereact/confirmdialog';
import parse from 'html-react-parser';
import * as sanitizeHtml from 'sanitize-html';
import * as equal from 'fast-deep-equal';
import { DateRange } from '../controls/Grid/GridComponents/GridCalendar';
import { formatterDate } from './FormatterDate';

export interface Handler {
  (...args: any[]): any;
}

export interface I18NString {
  ru: string;
  en?: string;
  defaultOpen?: boolean;
}

export function isNullOrEmpty(value: string | Array<any>) {
  return value === undefined || value === null || value.length === 0;
}

export function buildUrl(url: string, options: { [key: string]: any }): string {
  const pattern = /\{(\w+)\}/g;
  return url.replace(pattern, (match, prop) => options[prop] || match);
}

export let tr: (message: I18NString) => string = function (
  message: I18NString,
): string {
  return message?.ru;
};

export const breakLine: (text: string) => any = function (text: string): any {
  const regex = /&#13;&#10;/g;
  return text.split(regex).map((line, idx) => (
    <span key={idx}>
      {line}
      <br />
    </span>
  ));
};

type AllowedAttributesType = {
  [key: string]: string[];
};
export const parseTagSanitizeAndWhitelist: (
  html: string,
  allowedTags?: string[],
  allowedAttributes?: '*' | AllowedAttributesType,
) => any = (html, allowedTags, allowedAttributes) => {
  const allowedAttributesProperty =
    allowedAttributes === '*' ? false : allowedAttributes;

  return allowedTags
    ? parse(
        sanitizeHtml(html, {
          allowedTags,
          allowedAttributes: allowedAttributesProperty,
        }),
      )
    : parse(sanitizeHtml(html));
};

export function initLanguage(language: string) {
  if (language === null || language.length === 0) return;
  language = language.toUpperCase();
  if (language.substr(0, 2) === 'EN') {
    tr = function (message: I18NString): string {
      if (message.en !== null && message.en.length > 0) return message.en;
      return message.ru;
    };
  }
}

let _incriment = Math.floor(Math.random() * (10000 - 0)) + 10000;
export function getRandomKey(): number {
  return _incriment++;
}

export abstract class Component<TProp, TState> extends React.Component<
  TProp,
  TState
> {
  // eslint-disable-next-line react/no-unused-class-component-methods
  protected tr: (message: I18NString) => string = tr;
}

export function sleep(milliseconds) {
  const start = new Date().getTime();
  for (let i = 0; i < 1e7; i++) {
    if (new Date().getTime() - start > milliseconds) {
      break;
    }
  }
}

export class Session {
  private static session_id: number;

  public static getSession(): number {
    return this.session_id;
  }

  public static setSession(id: number) {
    this.session_id = id;
  }
}

export function assign(target: any, ...argum: any[]) {
  // eslint-disable-next-line strict
  // "use strict";

  const output = Object(target);
  for (let index = 1; index < argum.length; index++) {
    const source = argum[index];
    if (source !== undefined && source !== null) {
      // eslint-disable-next-line no-restricted-syntax
      for (const nextKey in source) {
        if (Object.prototype.hasOwnProperty.call(source, nextKey)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
  }
  return output;
}

/**
 * @returns boolean - удалось ли совершить скролл
 */
export function goToAnchor(elementId: string): boolean {
  if (elementId !== '') {
    // TODO: ReactDOM - устарел
    // eslint-disable-next-line react/no-find-dom-node
    const node = ReactDOM.findDOMNode(document.getElementById(elementId));
    if (node) {
      if ('scrollIntoView' in node) {
        node.scrollIntoView({ behavior: 'smooth' });
      }
      return true;
    }
  }

  return false;
}

export type scrollPosition = {
  controlId: any;
  sectionId: any;
};
interface scrollToFieldProps {
  scrollPositionTo: scrollPosition;
  scrollPositionCurrent: scrollPosition;
}

/**
 * Проверяет можно ли выполнить скролл, если да то делает это, возвращая позицию скролла
 * @param scrollPositionTo
 * @param scrollPositionCurrent
 *
 * @returns scrollPositionTo/null, если не удалось совершить скролл - возвращает false, нужно повторить, когда якорный элемент отрендерится
 */
export function scrollToField({
  scrollPositionTo,
  scrollPositionCurrent,
}: scrollToFieldProps): scrollPosition | null | false {
  if (!equal(scrollPositionTo, scrollPositionCurrent)) {
    const anchorRes = goToAnchor(scrollPositionTo.controlId);

    // если не удалось совершить скролл - возвращаем false
    if (!anchorRes) return false;

    return scrollPositionTo;
  }
  return null;
}

export function getFiletExtension(filename: string) {
  return filename.substring(filename.lastIndexOf('.') + 1).toUpperCase();
}

export function checkFileExtension(
  filename: string,
  formates: Array<string>,
): boolean {
  const extension = getFiletExtension(filename);
  // Проверяем формат файла
  return formates.indexOf(extension) !== -1;
}

export class Guid {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // eslint-disable-next-line no-bitwise
      const r = (Math.random() * 16) | 0;
      // eslint-disable-next-line no-bitwise
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

export function clearNonNumberCharacters(str: string): string {
  let decimalSeparatorIndex = 0;
  return str
    .replace(/[^0-9,.-]/g, '') // удаляем все не цифры, не -, не точки с запятыми
    .replace(/(?!^)-/g, '') // удаляем не лидирующие -
    .replace(
      /[.,]/g,
      (
        match, // удаляем все точки и запятые кроме первой
        // eslint-disable-next-line no-nested-ternary
      ) =>
        match === '.' || match === ','
          ? decimalSeparatorIndex++ === 0
            ? match
            : ''
          : '',
    );
}

export function numberCommaToDot(str: string): string {
  if (str === null) {
    return null;
  }

  return clearNonNumberCharacters(str).replace(',', '.');
}
export function numberDotToComma(str: string): string {
  if (str === null) {
    return null;
  }

  return clearNonNumberCharacters(str).replace('.', ',');
}

export function strCommaToDot(str: string): string {
  if (str === null) {
    return null;
  }

  return str.replace(',', '.');
}

export function parseFloatCommaDot(str: string): number {
  if (str === null) {
    return null;
  }

  return parseFloat(numberCommaToDot(str.toString()));
}

export function numberToFixedString(val: any): string {
  if (val === null) {
    return null;
  }
  let fval = parseFloatCommaDot(val.toString());

  if (Number.isNaN(fval)) {
    return null;
  }
  fval = Math.round(fval * 100.0) / 100.0;

  return numberDotToComma(fval.toString());
}

export function roundCurrency(val: number): number {
  if (val === null) {
    return null;
  }
  return Math.round(val * 100.0) / 100.0;
}

export function notify(message: any, accept?: any, headerTitle?: string) {
  confirmDialog({
    message,
    header: headerTitle ?? 'Внимание!',
    accept,
    reject: null,
    acceptLabel: 'Ок',
    rejectLabel: ' ',
  });
}

export function confirm(message: string, accept: any, headerTitle?: string) {
  return confirmDialog({
    message,
    header: headerTitle ?? 'Внимание!',
    accept,
    reject: null,
    acceptLabel: 'Ок',
    rejectLabel: 'Отменить',
  });
}

export function getCountRequired(
  sections: Array<any>,
  checkPanel: Array<string>,
) {
  let count = 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const section of sections) {
    count += getCountRequiredInSection(section.controls, checkPanel);
  }

  return count;
}

export function getCountRequiredInSection(
  controls: Array<any>,
  checkPanel: Array<string>,
) {
  // eslint-disable-next-line no-restricted-syntax
  for (const ctrl of controls) {
    if (ctrl.type.toUpperCase() !== 'PANEL' && ctrl.required) {
      return 1;
    }
    if (checkPanel.indexOf(ctrl.id) > -1) {
      return getCountRequiredInSection(ctrl.controls, checkPanel);
    }
  }

  return 0;
}

export function trimDoubleSpaces(value: string): string {
  return value.replace(/ +(?= )/g, '');
}

export function trimString(length: number, value: any): string {
  return trimDoubleSpaces(
    value.length > length ? `${value.substring(0, length)}` : value,
  );
}

export const cn = (...args: Array<string | Record<string, boolean>>) => {
  const result = args.map((el) => {
    if (typeof el === 'string') return el;

    const keys = Object.keys(el);
    const objectResult = keys.filter((key) => el[key]);

    return objectResult.join(' ');
  });

  return result.join(' ');
};

export const isMaxDate = (maxDate: string, value: string) => {
  const maxNewDate = new Date(maxDate);
  maxNewDate.setDate(maxNewDate.getDate() + 1);

  return new Date(value) <= maxNewDate;
};

export const isMinDate = (minDate: string, value: string) => {
  const minNewDate = new Date(minDate);
  minNewDate.setDate(minNewDate.getDate() - 1);

  return new Date(value) >= minNewDate;
};

export const formatterDateValues = (date: string | DateRange) => {
  if (typeof date === 'object') {
    return Object.values(date)?.map((_date) => formatterDate(_date));
  }
  return formatterDate(date);
};

export const mappingErrorValuesForGroup = (ctrls) => {
  const _errors = {};

  ctrls?.forEach((item) => {
    _errors[item.controlId] = { ...item?.error, isError: true };
  });

  return _errors;
};

export const formatterPhone = (value: string) => {
  if (typeof value !== 'string') {
    return '';
  }
  /* eslint-disable no-useless-escape */
  const _str = value.replace(/[^\d\+]/gi, '');

  return _str.includes('+') ? _str : `+${_str}`;
};

export const getKeys = <T extends object>(obj: T) =>
  (Object?.keys(obj ?? {}) ?? []) as [keyof T];
export const getValues = <T extends object>(obj: T) =>
  (Object?.values(obj ?? {}) ?? []) as [T[keyof T]];
export const getEntries = <T extends object>(obj: T) =>
  (Object?.entries(obj ?? {}) ?? []) as [keyof T, T[keyof T]][];

export const flattenKeys = (object) => {
  const array = [];

  // eslint-disable-next-line guard-for-in
  for (const index in object) {
    const item = object[index];

    if (item && typeof item !== 'string' && item?.length) {
      // eslint-disable-next-line guard-for-in
      for (const key in item) {
        array.push(`group_${key}`);
      }
    } else {
      array.push(index);
    }
  }

  return array;
};

export const cleanObj = (items) => {
  if (!items) {
    return null;
  }
  const storage = {};

  // eslint-disable-next-line guard-for-in
  for (const index in items) {
    const item = items[index];
    if (item) {
      storage[index] = item;
    }
  }

  return storage;
};

export const uid = (): string =>
  String(Date.now().toString(32) + Math.random().toString(16)).replace(
    /\./g,
    '',
  );

export const createCounterMessage = (
  value: any,
  maxLength: number,
  minLength: number,
): string => {
  let message: string;

  if (value) {
    if (value.length > maxLength) {
      message = `Всего: ${value.length} ${
        maxLength ? `(Превышено на: ${value.length - maxLength})` : ''
      }`;
    } else if (value.length >= (minLength || 0)) {
      message = `Всего: ${value.length} ${
        maxLength ? `(Осталось: ${maxLength - value.length})` : ''
      }`;
    } else {
      message = `Всего: ${value.length} ${
        minLength ? `(Не хватает: ${minLength - value.length})` : ''
      }`;
    }
  } else {
    message = `Всего: 0 ${minLength > 0 ? `(Минимум: ${minLength})` : ''}`;
  }

  return message;
};

export const rows2cols = (a: any[]) => {
  const r = [];
  let t;

  for (let i = 0, iLen = a.length; i < iLen; i++) {
    t = a[i];

    for (let j = 0, jLen = t.length; j < jLen; j++) {
      if (!r[j]) {
        r[j] = [];
      }
      r[j][i] = t[j];
    }
  }
  return r;
};

export const replacer = (
  data: string,
  sourceObject: { [key: string]: any },
) => {
  let result = data;
  // eslint-disable-next-line guard-for-in
  for (const key in sourceObject) {
    // @ts-ignore
    result = result.replaceAll(`:${key}`, sourceObject[key]);
  }
  return result;
};

export const getLastRowForSum = (values, schema): { [key: string]: any } => {
  if (!values || values?.find((item) => item?.key === 'sumCol')) {
    return null;
  }

  let result = {};

  if (schema?.extra?.funcRow) {
    // eslint-disable-next-line guard-for-in
    for (const index in schema.extra.funcRow) {
      const groups = [];

      const item: { target: string; action: string } =
        schema.extra.funcRow[index];
      if (item.action === 'sumCol') {
        result[item.target] = values.reduce((acc, itemState) => {
          let itemStateTarget;
          if (itemState?.[item.target]) {
            itemStateTarget = +itemState[item.target];
          } else if (itemState.groups) {
            groups.push(itemState.groups);
          }

          return acc + itemStateTarget;
        }, 0);
      }

      if (groups.length) {
        result = cleanObj({
          ...result,
          ...rows2cols(groups.reverse()).reduce(
            (groupsAcc, groupsItem, index) => {
              const key = `group_${index}`;
              return {
                ...groupsAcc,
                [key]: groupsItem.reduce((a, b) => a + +b[item.target], 0),
              };
            },
            {},
          ),
        });
      }
    }
  }

  // Заполним недостающие поля в последней строке (если она не нулл)
  if (getKeys(result).length > 0) {
    // Определим обьект с полями которых нет
    const needFields = [];
    for (const value in values[values.length - 1]) {
      if (!result?.[value]) {
        needFields.push(value);
      }
    }

    // Запишем недостающие поля
    for (const needField of needFields) {
      if (
        needField === 'key' ||
        needField === 'isEdit' ||
        needField === 'groups'
      ) {
        continue;
      }
      result[needField] = '';
    }
  }

  return getKeys(result).length > 0 ? result : null;
};

export const createFile = (data, mimetype = 'text/plain') =>
  `data:${mimetype};charset=utf-8,${encodeURIComponent(data)}`;

export const createFileInstance = (data: Array<any>, name: string) => {
  return new File(data, name);
};

export const blobToBase64 = (blob) =>
  new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });

export const blobToArrayBuffer = (messageFile): Promise<ArrayBuffer> => {
  const MAX_FILE_SIZE = 25000000;
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = function () {
      // @ts-ignore
      resolve(this.result);
    };

    if (messageFile.size > MAX_FILE_SIZE) {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(
        `Файл для подписи не должен превышать ${MAX_FILE_SIZE / 1000000}МБ`,
      );

      return;
    }

    fileReader.readAsArrayBuffer(messageFile);
  });
};

export const arrayBufferToBase64 = (buffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
  const lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
  let bufferLength = base64.length * 0.75;
  const len = base64.length;
  let i;
  let p = 0;
  let encoded1;
  let encoded2;
  let encoded3;
  let encoded4;

  if (base64[base64.length - 1] === '=') {
    bufferLength--;
    if (base64[base64.length - 2] === '=') {
      bufferLength--;
    }
  }

  const arraybuffer = new ArrayBuffer(bufferLength);
  const bytes = new Uint8Array(arraybuffer);

  for (i = 0; i < len; i += 4) {
    encoded1 = lookup[base64.charCodeAt(i)];
    encoded2 = lookup[base64.charCodeAt(i + 1)];
    encoded3 = lookup[base64.charCodeAt(i + 2)];
    encoded4 = lookup[base64.charCodeAt(i + 3)];

    bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
    bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
    bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
  }

  return arraybuffer;
};

export const b64toBlob = async (base64) =>
  fetch(base64).then((res) => res.blob());

export const blobToFile = (theBlob: any, fileName: string): File =>
  new File([theBlob], fileName, {
    type: theBlob.type,
  });

export const getDigits = (str) => {
  if (typeof str === 'string') {
    return str.replace(/\D/g, '');
  }
  return '';
};

export const valueObjectToArray = (value: {
  [key: string]: any;
}): { controlId: string; value: any }[] =>
  Object.keys(value).reduce(
    (acc, item) => [
      ...acc,
      {
        controlid: item,
        value: value[item] ? value[item] : null,
      },
    ],
    [],
  );

export const getUrlParamsEntries = (data, urlParams) => {
  return getEntries(data?.urlParams).reduce((acc, [url, byID]) => {
    // @ts-ignore
    acc += `/${url}/${urlParams?.[byID]}`;
    return acc;
  }, '');
};
